<template>
  <div class="notfound-page">
    <img src="@/assets/img/404.jpg" alt="404" />
    <p class="sorry">404</p>
  </div>
</template>
<style lang="scss">
.notfound-page {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  img {
    display: block;
    height: 400px;
    margin: 0 auto 50px;
  }
  .sorry {
    font-size: 45px;
    line-height: 68px;
  }
}
</style>
